import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertySelectComponent } from '@shared/component/form-controls/select/property-select/property-select.component';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PreloaderModule, ValidationErrorModule } from '@shared/component';

@NgModule({
  declarations: [PropertySelectComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    ValidationErrorModule,
    PreloaderModule
  ],
  exports: [PropertySelectComponent]
})
export class PropertySelectModule { }
